import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { MAX_BOM_ITEM_GROUP_WAREHOUSES } from './constraints.js';
const DUPLICATE_WAREHOUSE_MESSAGE = 'Choose each warehouse only once.';
// Shared by bomItemGroupMemberSchema (create paths) and updateBomItemInputSchema (Task 6b) so the
// max/dedupe rules can't drift between them -- each caller still appends its own .default([]) or
// .optional() on top, since create and update disagree on whether the field is required.
export const warehouseLocationGroupIdsSchema = z
    .array(requiredUuidString('Warehouse is required.', 'Invalid warehouse selection.'))
    .max(MAX_BOM_ITEM_GROUP_WAREHOUSES, `An option can be tied to at most ${MAX_BOM_ITEM_GROUP_WAREHOUSES} warehouses.`)
    .refine((ids) => new Set(ids).size === ids.length, DUPLICATE_WAREHOUSE_MESSAGE);
//# sourceMappingURL=warehouse-location-group-ids-schema.js.map